import React from 'react';
import { Button } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../AuthProvider";

const CustomHeader = ({ leftTopText, leftBottomText, rightTopText, rightBottomText, leftBottomExtraText }) => {
  const navigate = useNavigate();
  const {user} = useAuth();
  const name = user.FirstName + " " + user.LastName;
  const userType = user.Type;
  if(userType === 'Admin') {
    rightTopText = 'Logged in as Admin';
  } else if(userType === 'Authorizer') {
    rightTopText = 'Logged in as Authorizer';
  }
  else if(userType === 'ASD') {
    rightTopText = 'Logged in as ASD';
  }
  else if(userType === 'Viewer') {
    rightTopText = 'Logged in as Viewer';
  }
  else {
    rightTopText = 'Logged in as User';
  }

  return (
    // <div style={styles.headerContainer}>
    //   <div style={styles.leftSection}>
    //     <p style={styles.welcomeText}>{leftTopText}, {rightBottomText}!</p>
    //     <h2 style={styles.approvalsText}>Approvals <span>{leftBottomText}</span></h2>
    //   </div>
    //   <div style={styles.rightSection}>
    //     <p style={styles.rightTopTextText}>Logged in as {rightTopText}</p>
    //     <p style={styles.rightBottomTextText}>{rightBottomText}</p>
    //     <Button
    //       type="link"
    //       icon={<LogoutOutlined style={styles.logoutIcon} />}
    //       onClick={handleLogout}
    //     />
    //   </div>
    // </div>
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '20px',
      }}
    >
      <div className='row'>
        <div style={{ fontWeight: '400', fontSize: '16px', lineHeight: '24px' }}>{leftTopText}</div>
        <div style={{ fontWeight: '600', fontSize: '32px', marginTop: '8px' }}>{leftBottomText} <span style={{ color: '#616161' }}>{leftBottomExtraText}</span></div>
      </div>

      {/* <div style={{ display: 'flex', alignItems: 'center' }}>
        <div className='row' style={{ marginRight: '10px' }}>
          <div style={{ fontWeight: '400', fontSize: '16px', lineHeight: '24px', marginBottom: '4px' }}>{rightTopText}</div>
          <div style={{ fontWeight: '600', fontSize: '18px', lineHeight: '21.78px', textAlign: 'end' }}>{name}</div>
        </div>
        <Button icon={<LogoutOutlined />} onClick={handleLogout} type='text' size='large' />
      </div> */}
    </div>
  );
};

const styles = {
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 20px',
    backgroundColor: '#f5f5f5',
  },
  leftSection: {
    display: 'flex',
    flexDirection: 'column',
  },
  rightSection: {
    display: 'flex',
    alignItems: 'center',
  },
  welcomeText: {
    margin: 0,
    fontSize: '14px',
    color: '#777',
  },
  approvalsText: {
    margin: 0,
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#333',
  },
  rightTopTextText: {
    margin: 0,
    fontSize: '14px',
    color: '#999',
    marginRight: '10px',
  },
  rightBottomTextText: {
    margin: 0,
    fontSize: '16px',
    fontWeight: 'bold',
    marginRight: '10px',
  },
  logoutIcon: {
    fontSize: '20px',
    color: '#000',
  },
};

export default CustomHeader;
